import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { withTheme } from '@mui/styles';

class QualificationSelect extends React.Component {
    render() {
        const { value, onChange, qualifications, error, isRequired, noLabel, disabled, afficheAide, theme } = this.props;

        let label = "";

        if (noLabel === undefined) {
            label = "Qualification";
        }

        let aide = '';
        if (afficheAide) {
            let qualification = qualifications.find(x => x.id === value);
            if (qualification) {
                aide = qualification.aide;
            }
        }

        return (
            <TextField
                select
                error={error !== undefined}
                required={isRequired}
                name="qualificationId"
                label={label}
                value={value}
                onChange={onChange}
                helperText={error ? error.errorMsg : afficheAide && aide ? `⚠️ ${aide}` : ''}
                fullWidth
                disabled={disabled}
                FormHelperTextProps={
                    afficheAide && !error && aide ? {
                        style: theme.style.aideMessage                        
                    } : undefined
                }
            >
                <MenuItem key="first" value={0}>
                    <em>Sélectionner une qualification</em>
                </MenuItem>
                {qualifications.map(qualification => (
                    <MenuItem key={qualification.id} value={qualification.id}>
                        {qualification.libelle}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}

QualificationSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    qualifications: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    noLabel: PropTypes.bool,
    disabled: PropTypes.bool.isRequired,
    theme: PropTypes.object,
};

export default withTheme(QualificationSelect);
